<template>
  <div class="info_tip">
    <div>
      <span v-for="(item,index) in crumbs" :key="item">{{ index > 0 ? '&nbsp;&gt;&nbsp;' : '' }}{{ item }}</span>
      <!-- 进度数据&gt;&nbsp;电力消耗&gt;&nbsp;工业用电量 -->
    </div>
  </div>
</template>

<script setup>
  import { ref, watch } from 'vue';
  import { useStore } from 'vuex';

  let store = useStore();
  let crumbs = ref([]);

  watch(
    () => store.state.crumbs,
    (nv) => {
      crumbs.value = nv.split(',');
    }
  );
</script>

<style lang="less" scoped>
  .info_tip {
    padding: 0 20px 0 10px;
    line-height: 46px;
    background-color: #fff;
    color: #666;
    & > div {
      padding-left: 25px;
      border-bottom: 1px solid #e9e9e9;
    }
  }
</style>